import { h, Component } from 'preact';
import { sortObjectByOrder } from 'utils/utils';
import s from 'components/bolt/uarFooter/uarFooter.sss';

export default class UarFooter extends Component {

	render({ data }) {
		const copyrights = sortObjectByOrder(data.copyright);
		const links = sortObjectByOrder(data.links);
		const logo = data.logo;

		return (
			<footer class={s.footer}>
				<img class={s.logo} src={logo.src} alt={logo.altText} />
				<div class={s.content}>
					<div class={s.copyrights}>
						{copyrights.map(copyright => (
							<a class={s.copyright} href={copyright.url} target="_blank">
								{copyright.$copy}
							</a>
						))}
					</div>
					<div class={s.links}>
						{links.map(link => {
							if (link.url === '@otcookiesettings') {
								return (
									<button class={s.link} onClick={() => window.OneTrust.ToggleInfoDisplay()}>
										{link.$copy}
									</button>
								);
							}
							return (
								<a class={s.link} href={link.url} target="_blank">
									{link.$copy}
								</a>
							);
						})}
					</div>
				</div>
			</footer>
		);
	}
}
